import {
  BILLS_REQUEST,
  BILLS_SUCCESS,
  BILLS_ERROR,
} from "@/store/actions/bills.js";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "@/store/actions/auth";

const state = {
  bills_get_status: "",
  bills_once_loaded: false,
  bills: [],
};

const getters = {
  getBills: state => state.bills,
  getBillById: state => id => state.bills.find(b => b.id == id),
  isBillsLoading: state => state.bills_get_status === 'loading',
  isBillsFailed: state => state.bills_get_status === 'error',
  billsOnceLoaded: state => state.bills_once_loaded,
};

const actions = {
  [BILLS_REQUEST]: ({ commit, dispatch }) => {
    commit(BILLS_REQUEST);
    HTTP({ url: "bills" })
      .then(resp => {
        commit(BILLS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(BILLS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
};

const mutations = {
  [BILLS_REQUEST]: state => {
    state.bills_get_status = "loading";
  },
  [BILLS_SUCCESS]: (state, data) => {
    state.bills_get_status = "success";
    Vue.set(state, "bills", data);
    state.bills_once_loaded = true;
  },
  [BILLS_ERROR]: state => {
    state.bills_get_status = "error";
    state.bills_once_loaded = true;
  },

  [AUTH_LOGOUT]: state => {
    state.bills_get_status = "";
    state.bills_once_loaded = false;
    state.bills = [];
    state.bills_add_status = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};